import { cloneDeepWith, isEmpty, isNumber, isString, toString } from "lodash";
import type { SavedOrdersListItem, SavedOrderWithNames } from "./orderTypes";
import { labelForTodoItem } from "./todos/labelForTodoItem";

export interface IndexEntry {
  readonly id: string;
  readonly index: string;
}

export interface OrdersIndex {
  [id: string]: IndexEntry;
}

type SavedOrder = Omit<SavedOrderWithNames, "customerAccountManagerId" | "supervisorId">;

export function getOrdersIndex(orders: SavedOrder[]): OrdersIndex {
  return orders.map((o) => getIndexFor(o)).reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {});
}

function getIndexFor(value: SavedOrder): IndexEntry {
  const strings: string[] = [];
  joinFetch(value, strings);
  return {
    id: value.id,
    index: strings.join("\n").toLocaleLowerCase(),
  };
}

function joinFetch(value: SavedOrder, values: string[]) {
  const excludedKeys: (string | number)[] = [
    "info",
    "providerId",
    "customerId",
    "files",
    "url",
    "status",
    "price",
    "advance",
    "paymentSum",
    "customerAccountManagerId",
    "supervisorId",
    "participantsNumber",
  ] as const;
  return cloneDeepWith(value, (val, key) => {
    if (key !== undefined && excludedKeys.includes(key)) {
      return null;
    }
    if (key === "todos") {
      Object.entries(val as Record<string, boolean>)
        .filter(([, v]) => !v)
        .map(([k]) => labelForTodoItem(k as keyof SavedOrdersListItem["todos"]))
        .forEach((v) => values.push(v));
      return null;
    }
    if ((isString(val) && !isEmpty(val)) || isNumber(val)) {
      values.push(toString(val));
    }
  });
}
